import React from "react";
import type { NavigationLink } from "../Footer.types";

interface FooterNavColumnProps {
    title?: string;
    links: NavigationLink[];
    className?: string;
}

const FooterNavColumn: React.FC<FooterNavColumnProps> = ({
    title,
    links,
    className = "",
}) => {
    if (!links || links.length === 0) return null;

    return (
        <div className={className}>
            {title && <h3 className="text-white mb-4 font-semibold">{title}</h3>}
            <ul>
                {links.map((link, i) => (
                    <li key={i} className="mb-2">
                        <a
                            href={link.href}
                            className="text-gray-300 text-sm hover:text-white transition-colors duration-200"
                        >
                            {link.label}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FooterNavColumn;